var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trend"},_vm._l((_vm.value),function(v,index){return _c('div',{key:index,staticClass:"trend-item",style:(_vm.styleItem(v, index))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }